














































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel,HoriScroll } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { Yuyue, Inquiry, Hd } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        HoriScroll
    },
})
export default class ReceiptManage extends Vue {
    public $refs: {
        date: HTMLFormElement;
    };
    public form:any ={
        wareHouseName:'',
    }
    public searchValue={
        wareHouseId:'',    
        wareHouseName:''    
    }
    public optionSingleHeightTime = {
    isSingleRemUnit: true,
    singleHeight: 2.5, //单行停顿间距
    waitTime: 3000, //单行停顿时间
    limitMoveNum: 10,
  };
    public year:any = ''
    public month:any = ''
    public date:any = ''
    public hour:any = ''
    public minute:any = ''
    public second:any = ''
    public orderList:any = [
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'1','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'2','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'3','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'4','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'5','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'6','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'7','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'8','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'9','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'10','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'11','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'12','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'13','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'14','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'15','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'16','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'17','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'18','appointmentTypeStr':'装货'},
        {'docks':'一号月台、二号月台、单号月台','carCode':'苏L61154','supplier':'若得物流','queueNumber':'19','appointmentTypeStr':'装货'},
        ];
    public isFullscreen:any = false;
    screenFull(){
        // if(!screenfull.enabled){
        //     this.$message({
        //     message:'浏览器不支持',
        //     type:'warning'
        //     })
        //     return false
        // }
        // console.log(screenfull);
        // this.isFullscreen=screenfull.isFullscreen;
        // screenfull.toggle();
    }
    // @Watch('isFullscreen')
    // screenChange(val){
    //     console.log('this.isFullscreen',this.isFullscreen);
    //     if(val){
    //         console.log('全屏了');
    //     }else{
    //         console.log('非全屏了');
    //     }
    // }
    checkFull(){
        // let isFull=document.fullscreenEnabled||window.fullScreen||document.webkitIsFullScreen||document.msFullscreenEnabled;        
        // console.log('checkFull',isFull);
        // if(isFull===undefined){

        // isFull=false;
        // }
        // return isFull;
    }
    keydown(event) {
      if (event.keyCode === 122) {
        event.preventDefault()
        event.returnValue = false
      }
    }
    onresize(event) {
      let winFlag = window.innerHeight === window.screen.height
    //   let isFull = window.fullScreen || document.webkitIsFullScreen
 
    //   if (isFull === undefined) {
    //     this.isFullscreen = winFlag
    //   } else {
    //     this.isFullscreen = winFlag || isFull
    //   }
    }
    public tempReservedList:any =[]
    public yyData:any =[];
    public pdzData:any =[];
    public jhzData:any =[];
    public todayCont:any ={
        appointCount: 0,
        bePresentCount: 0,
        queuingCount: 0,
        loadingCount: 0,
        loadFinishCount: 0
    }
    created(){
        // window.addEventListener('resize', this.onresize)
        // window.addEventListener('keydown', this.keydown)
        // this.form.calledList = this.orderList;
        // for (var i = 0; i < this.form.calledList.length; i += 10) {
        //     this.tempReservedList.push(this.form.calledList.slice(i, i + 10));
        // }
        
    }
    mounted() {        
        this.initCk();
        // setInterval(()=>{
        //     let now=new Date();
        //     this.year=now.getFullYear()+"";
        //     this.month=(now.getMonth()+1).toString();
        //     this.date=now.getDate()+'';
        //     this.hour=now.getHours()+'';
        //     this.minute=now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes()+'';
        //     this.second=now.getSeconds()<10?'0'+now.getSeconds():now.getSeconds()+'';

        // },1000);
    }
    closeroll(){
        if(this.interval){
            clearInterval(this.interval);
            this.interval = null;
        }
    }
    beforeDestroy() {    
    //   window.removeEventListener('resize', this.onresize)
    //   window.removeEventListener('keydown', this.keydown)
      this.closeroll();
    }
    public cks:any = [];
    async initCk(){
        this.cks = [];
        let uid = JSON.parse(
            sessionStorage.getItem('id') ? sessionStorage.getItem('id') : JSON.parse(localStorage.getItem('mlssloginAd')).id
        );
        let res = await Yuyue.GetWareHouseList({name:'',keeperName:'',enabled:true,skip:0,count:-1});
        res.data.forEach(e => {
                this.cks.push({ value: e.name, id: e.id})
            });
        console.log('res',res,this.cks);
         if(!this.searchValue.wareHouseId){
            this.searchValue.wareHouseId = this.cks&&this.cks.length>0 ? this.cks[0].id:'';
            this.searchValue.wareHouseName = this.cks&&this.cks.length>0 ? this.cks[0].value:'';
            console.log('[enter',this.searchValue.wareHouseId,this.cks[0]);
        }
        this.handleSearch(this.searchValue.wareHouseId);
        // this.form.queuingList = this.orderList;
        
    }
    public yyyList:any = [];
    public pdzList:any = [];
    public jhzList:any = [];
    public yyyTotal:any = 0;
    public pdzTotal:any = 0;
    public jhzTotal:any = 0;
    public tips:any = '';
    async handleSearch(id){
       console.log('handleserch-->',id);
       if(!id){
         //this.$message.warning('请先选择仓库!');
         return;
       }
       this.closeroll();
       let wareName = this.cks.filter(v=>{
         if(v.id == id){
            return v;
         }
       })
       this.searchValue.wareHouseName = wareName&&wareName.length>0?wareName[0].value:'';     
       this.yyyList =[];
       this.pdzList =[];
       this.jhzList =[];
       this.yyyTotal = 0;
       this.pdzTotal = 0;
       this.jhzTotal = 0;
       this.todayCont.appointCount = 0;
       this.todayCont.bePresentCount = 0;
       this.todayCont.queuingCount = 0;
       this.todayCont.loadingCount = 0;
       this.todayCont.loadFinishCount = 0;
       this.tips = '';
        //1 预约中 3排队中 4叫号中
        Yuyue.GetBoradDatas({
            wareHouseId:id,
            status:1,
            skip:0,
            count:-1}).then(res=>{
            console.log('res',res);
            this.yyData = res.data;
            this.yyyTotal = res.total;
            for (var i = 0; i < this.yyData.length; i += 10) {
                this.yyyList.push(this.yyData.slice(i, i + 10));
            }
        })
        Yuyue.GetBoradDatas({
            wareHouseId:id,
            status:3,
            skip:0,
            count:-1}).then(res=>{
            this.pdzData = res.data;
            this.pdzTotal = res.total;
            for (var i = 0; i < this.pdzData.length; i += 10) {
                this.pdzList.push(this.pdzData.slice(i, i + 10));
            }
        })
        Yuyue.GetBoradDatas({
            wareHouseId:id,
            status:4,
            skip:0,
            count:-1}).then(res=>{
            this.jhzData = res.data;
            this.jhzTotal = res.total;
            for (var i = 0; i < this.jhzData.length; i += 10) {
                this.jhzList.push(this.jhzData.slice(i, i + 10));
            }
        })
        Yuyue.TodayData({wareHouseId:id}).then(res=>{
            if(res){
                this.todayCont = {...res}
            }else{
                this.todayCont.appointCount = 0;
                this.todayCont.bePresentCount = 0;
                this.todayCont.queuingCount = 0;
                this.todayCont.loadingCount = 0;
                this.todayCont.loadFinishCount = 0;
            }           
        })
        Yuyue.getTips(id).then(res=>{            
            this.tips = res.extData;
            // if(id == 30){
            //     this.tips = '33333333333333333333333333333333333333333333333333333333333333335555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555'    
            // }            
            console.log('tips-->',res);
        })
       
         console.log('handlesearch',id);
         this.rollquery();
    }    
    interval:any = null;
    rollquery(){
        this.interval=setInterval(this.gettips,10000);
    }
    gettips(){
        if(this.searchValue.wareHouseId){
            Yuyue.getTips(this.searchValue.wareHouseId).then(res=>{
            this.tips = res.extData;
            //this.tips = 'start5555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555end'
            console.log('tips-->',res);
        })
        }        
    }
    hasAuth(auth) {
        var authlist = sessionStorage.getItem('permissions') ? sessionStorage.getItem('permissions').split(',') : [];
        if (authlist.includes(auth)) {
            return true;
        } else {
            this.$message.warning('没有权限访问');
            return false;
        }
    }
    get sycount() {
        return this.$store.state.rongCloud.causeAuditCount;
    }
    get ylcount() {
        return this.$store.state.rongCloud.advanceAuditCount;
    }
    get bxcount() {
        return this.$store.state.rongCloud.reimburseAuditCount;
    }

    public pickerOptions:any={
        shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date);
            }
          }]
    } 
    tableRowClassName({row, rowIndex}){
         console.log('row-->',row,rowIndex);
         if (row.isPass) {
          return 'warning-row';
        }else if(rowIndex%2==1) {
             return 'stripe-row';
        }else{
            return '';
        }
    }
}
